import React from "react"
import PropTypes from "prop-types"
const defaultInsuranceOptions = [
  { value: "", label: "Select Insurance Provider" },
  { value: "Aetna", label: "Aetna" },
  { value: "Anthem", label: "Anthem" },
  {
    value: "Blue Cross Blue Shield: non-California",
    label: "Blue Cross Blue Shield: non-California",
  },
  {
    value: "Blue Cross Blue Shield: California",
    label: "Blue Cross Blue Shield: California",
  },
  { value: "Blue Shield: Federal", label: "Blue Shield: Federal" },
  { value: "Blue Shield: of California ", label: "Blue Shield: of California" },
  { value: "Cigna", label: "Cigna" },
  { value: "Health Net", label: "Health Net" },
  { value: "Medi-Cal", label: "Medi-Cal" },
  {
    value: "Mercy Care Plan of Arizona",
    label: "Mercy Care Plan of Arizona",
  },
  { value: "Other", label: "Other" },
  { value: "Self-pay", label: "Self-pay" },
  { value: "UnitedHealthcare (UHC)", label: "UnitedHealthcare (UHC)" },
]

const vbcInsuranceOptions = [
  { value: "", label: "Select Insurance Provider" },
  { value: "BCBS-MA", label: "BCBS-MA" },
  {
    value: "Harvard Pilgrim Health Care",
    label: "Harvard Pilgrim Health Care",
  },
  { value: "MassHealth Health Plans", label: "MassHealth Health Plans" },
  { value: "Tufts Health Plan", label: "Tufts Health Plan" },
  { value: "Other", label: "Other" },
]
export const InsuranceOptionDropdown = ({ apiData, ...props }) => {
  if (
    (apiData &&
      apiData.findAFacilityuser &&
      apiData.findAFacilityuser.findAFacility === "Burlington, MA") ||
    apiData.findAFacilityuser.findAFacility === "Quincy, MA" ||
    apiData.findAFacilityuser.findAFacility === "Braintree, MA" ||
    apiData.findAFacilityuser.findAFacility === "Danvers, MA"
  ) {
    return (
      <select
        className="form-select form-control"
        id="insurance_name"
        name="insurance_name"
        {...props}
      >
        {vbcInsuranceOptions.map(option => (
          <option
            disabled={!option.value}
            key={option.value}
            value={option.value}
          >
            {option.label}
          </option>
        ))}
      </select>
    )
  }
  return (
    <select
      className="form-select form-control"
      id="insurance_name"
      name="insurance_name"
      {...props}
    >
      {defaultInsuranceOptions.map(option => (
        <option
          disabled={!option.value}
          key={option.value}
          value={option.value}
        >
          {option.label}
        </option>
      ))}
    </select>
  )
}

InsuranceOptionDropdown.propTypes = {
  apiData: PropTypes.object.isRequired,
}
